module.exports = __webpack_public_path__ + "customer2.png?047b82ef5fbecc548125ada7a81ca0cc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/customer2.png
// module id = 114
// module chunks = 0